import {
  deleteRequest,
  getRequest,
  postRequest,
  postRequestFormData,
  patchRequest,
  patchRequestFormData,
  putRequest,
  putRequestFormData
} from "../coreFIles/helper";

// Keep adding page-wise API functions here as you share endpoints.
// Pattern matches sample_react_app:
// export const someAction = (data) => postRequest("endpoint", data).then((res) => res.data);

export const adminLoginAction = (data) => {
  return postRequest("/admin/login", data).then((res) => res.data);
};

export const adminProfileAction = (data) => {
  return getRequest("/admin/me", data).then((res) => res.data);
};

export const dashboardStatsAction = (data) => {
  return getRequest("/admin/dashboard", data).then((res) => res.data);
};

export const adminUsersListAction = (params) => {
  return getRequest("/admin/users", params).then((res) => res.data);
};

export const adminUserDeleteAction = (id) => {
  return deleteRequest(`/admin/users/${id}`).then((res) => res.data);
};

export const adminUserUpdateStatusAction = (id, status) => {
  return putRequest(`/admin/users/${id}/status`, { status }).then((res) => res.data);
};

export const adminUserCreateAction = (formData) => {
  return postRequestFormData("/admin/users", formData).then((res) => res.data);
};

export const adminUsersImportAction = (data) => {
  return postRequest("/admin/users/import", data).then((res) => res.data);
};

export const adminUserGetAction = (id) => {
  return getRequest(`/admin/users/${id}`).then((res) => res.data);
};

export const adminUserJournalEntriesAction = (id, params) => {
  return getRequest(`/admin/users/${id}/journal-entries`, params).then((res) => res.data);
};

export const adminUserSavedItemsAction = (id, params) => {
  return getRequest(`/admin/users/${id}/saved-items`, params).then((res) => res.data);
};

export const adminUserSeenHacksAction = (id, params) => {
  return getRequest(`/admin/users/${id}/seen-hacks`, params).then((res) => res.data);
};

export const adminUserNotificationsAction = (id, params) => {
  return getRequest(`/admin/users/${id}/notifications`, params).then((res) => res.data);
};

export const adminUserCourseProgressAction = (id, params) => {
  return getRequest(`/admin/users/${id}/course-progress`, params).then((res) => res.data);
};

export const adminUserCourseWeekSectionsAction = (id, weekId) => {
  return getRequest(`/admin/users/${id}/course-progress/weeks/${weekId}`).then((res) => res.data);
};

export const adminUserPurchasesAction = (id, params) => {
  return getRequest(`/admin/users/${id}/purchases`, params).then((res) => res.data);
};

export const adminUserCouponRedemptionsAction = (id, params) => {
  return getRequest(`/admin/users/${id}/coupon-redemptions`, params).then((res) => res.data);
};

export const adminUserActivityAction = (id, params) => {
  return getRequest(`/admin/users/${id}/activity`, params).then((res) => res.data);
};

export const adminUserDevicesAction = (id) => {
  return getRequest(`/admin/users/${id}/devices`).then((res) => res.data);
};

export const adminUserActivityListAction = (params) => {
  return getRequest("/admin/user-activity", params).then((res) => res.data);
};

export const adminUserActivityGetAction = (id) => {
  return getRequest(`/admin/user-activity/${id}`).then((res) => res.data);
};

export const adminUserActivityTypesAction = () => {
  return getRequest("/admin/user-activity/types").then((res) => res.data);
};

export const adminPurchasesListAction = (params) => {
  return getRequest("/admin/purchases", params).then((res) => res.data);
};

export const adminCourseProgressReportAction = (params) => {
  return getRequest("/admin/reports/course-progress", params).then((res) => res.data);
};

export const adminPurchaseGetAction = (id) => {
  return getRequest(`/admin/purchases/${id}`).then((res) => res.data);
};

export const adminPurchasesProvidersAction = () => {
  return getRequest("/admin/purchases/providers").then((res) => res.data);
};

export const adminCouponsListAction = (params) => {
  return getRequest("/admin/coupons", params).then((res) => res.data);
};

export const adminCouponGenerateCodeAction = (params) => {
  return getRequest("/admin/coupons/generate-code", params).then((res) => res.data);
};

export const adminCouponGetAction = (id) => {
  return getRequest(`/admin/coupons/${id}`).then((res) => res.data);
};

export const adminCouponCreateAction = (data) => {
  return postRequest("/admin/coupons", data).then((res) => res.data);
};

export const adminCouponUpdateAction = (id, data) => {
  return patchRequest(`/admin/coupons/${id}`, data).then((res) => res.data);
};

export const adminCouponDeleteAction = (id) => {
  return deleteRequest(`/admin/coupons/${id}`).then((res) => res.data);
};

export const adminCouponRedemptionsListAction = (params) => {
  return getRequest("/admin/coupon-redemptions", params).then((res) => res.data);
};

export const adminCouponRedemptionGetAction = (id) => {
  return getRequest(`/admin/coupon-redemptions/${id}`).then((res) => res.data);
};

export const adminCourseSalesListAction = (params) => {
  return getRequest("/admin/course-sales", params).then((res) => res.data);
};

export const adminCourseSaleGetAction = (id) => {
  return getRequest(`/admin/course-sales/${id}`).then((res) => res.data);
};

export const adminCourseSaleCreateAction = (data) => {
  return postRequest("/admin/course-sales", data).then((res) => res.data);
};

export const adminCourseSaleUpdateAction = (id, data) => {
  return patchRequest(`/admin/course-sales/${id}`, data).then((res) => res.data);
};

export const adminCourseSaleDeleteAction = (id) => {
  return deleteRequest(`/admin/course-sales/${id}`).then((res) => res.data);
};

export const adminUserOnboardingAnswersSummaryAction = (id, params) => {
  return getRequest(`/admin/users/${id}/onboarding-answers`, params).then((res) => res.data);
};

export const adminUserOnboardingAnswersBeginningAction = (id, params) => {
  return getRequest(`/admin/users/${id}/onboarding-answers/beginning`, params).then((res) => res.data);
};

export const adminUserOnboardingAnswersEndAction = (id, params) => {
  return getRequest(`/admin/users/${id}/onboarding-answers/end`, params).then((res) => res.data);
};

export const adminUserOnboardingAnswersResultAction = (id, params) => {
  return getRequest(`/admin/users/${id}/onboarding-answers/result`, params).then((res) => res.data);
};

export const adminUserGrowthSnapshotAnswersSummaryAction = (id, params) => {
  return getRequest(`/admin/users/${id}/growth-snapshot-answers`, params).then((res) => res.data);
};

export const adminUserGrowthSnapshotAnswersBeginningAction = (id, params) => {
  return getRequest(`/admin/users/${id}/growth-snapshot-answers/beginning`, params).then((res) => res.data);
};

export const adminUserGrowthSnapshotAnswersEndAction = (id, params) => {
  return getRequest(`/admin/users/${id}/growth-snapshot-answers/end`, params).then((res) => res.data);
};

export const adminUserGrowthSnapshotAnswersResultAction = (id, params) => {
  return getRequest(`/admin/users/${id}/growth-snapshot-answers/result`, params).then((res) => res.data);
};

export const adminUserGrowthSnapshotAnswersLookingBackAction = (id, params) => {
  return getRequest(`/admin/users/${id}/growth-snapshot-answers/looking-back`, params).then((res) => res.data);
};

export const adminUserUpdateAction = (id, formData) => {
  return putRequest(`/admin/users/${id}`, formData).then((res) => res.data);
};

// Courses
export const adminCoursesListAction = (params) => {
  return getRequest("/admin/courses", params).then((res) => res.data);
};

export const adminCourseGetAction = (id) => {
  return getRequest(`/admin/courses/${id}`).then((res) => res.data);
};

export const adminCourseCreateAction = (formData) => {
  return postRequestFormData("/admin/courses", formData).then((res) => res.data);
};

export const adminCourseUpdateAction = (id, formData) => {
  return putRequestFormData(`/admin/courses/${id}`, formData).then((res) => res.data);
};

export const adminCourseDeleteAction = (id) => {
  return deleteRequest(`/admin/courses/${id}`).then((res) => res.data);
};

// Course Weeks
export const adminCourseWeeksListAction = (courseId, params) => {
  return getRequest(`/admin/courses/${courseId}/weeks`, params).then((res) => res.data);
};

export const adminCourseWeekGetAction = (id) => {
  return getRequest(`/admin/course-weeks/${id}`).then((res) => res.data);
};

export const adminCourseWeekCreateAction = (courseId, data) => {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return postRequestFormData(`/admin/courses/${courseId}/weeks`, data).then((res) => res.data);
  }
  return postRequest(`/admin/courses/${courseId}/weeks`, data).then((res) => res.data);
};

export const adminCourseWeekUpdateAction = (id, data) => {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return putRequestFormData(`/admin/course-weeks/${id}`, data).then((res) => res.data);
  }
  return putRequest(`/admin/course-weeks/${id}`, data).then((res) => res.data);
};

export const adminCourseWeekDeleteAction = (id) => {
  return deleteRequest(`/admin/course-weeks/${id}`).then((res) => res.data);
};

// Course onboarding steps
export const adminCourseOnboardingStepsListAction = (courseId, params) => {
  return getRequest(`/admin/courses/${courseId}/onboarding-steps`, params).then((res) => res.data);
};

export const adminCourseOnboardingStepGetAction = (id) => {
  return getRequest(`/admin/course-onboarding-steps/${id}`).then((res) => res.data);
};

export const adminCourseOnboardingStepCreateAction = (courseId, formData) => {
  return postRequestFormData(`/admin/courses/${courseId}/onboarding-steps`, formData).then((res) => res.data);
};

export const adminCourseOnboardingStepUpdateAction = (id, formData) => {
  return putRequestFormData(`/admin/course-onboarding-steps/${id}`, formData).then((res) => res.data);
};

export const adminCourseOnboardingStepDeleteAction = (id) => {
  return deleteRequest(`/admin/course-onboarding-steps/${id}`).then((res) => res.data);
};

// Course step sections (master) + nested questions
export const adminCourseStepSectionsListAction = (params) => {
  return getRequest("/admin/step-sections", params).then((res) => res.data);
};

export const adminCourseStepSectionGetAction = (id) => {
  return getRequest(`/admin/course-step-sections/${id}`).then((res) => res.data);
};

export const adminCourseStepSectionCreateAction = (data) => {
  return postRequest("/admin/step-sections", data).then((res) => res.data);
};

export const adminCourseStepSectionUpdateAction = (id, data) => {
  return putRequest(`/admin/course-step-sections/${id}`, data).then((res) => res.data);
};

export const adminCourseStepSectionDeleteAction = (id) => {
  return deleteRequest(`/admin/course-step-sections/${id}`).then((res) => res.data);
};

export const adminStepSectionQuestionsListAction = (sectionId, params) => {
  return getRequest(`/admin/step-sections/${sectionId}/questions`, params).then((res) => res.data);
};

export const adminStepSectionQuestionGetAction = (sectionId, questionId) => {
  return getRequest(`/admin/step-sections/${sectionId}/questions/${questionId}`).then((res) => res.data);
};

export const adminStepSectionQuestionCreateAction = (sectionId, data) => {
  return postRequest(`/admin/step-sections/${sectionId}/questions`, data).then((res) => res.data);
};

export const adminStepSectionQuestionUpdateAction = (sectionId, questionId, data) => {
  return putRequest(`/admin/step-sections/${sectionId}/questions/${questionId}`, data).then((res) => res.data);
};

export const adminStepSectionQuestionDeleteAction = (sectionId, questionId) => {
  return deleteRequest(`/admin/step-sections/${sectionId}/questions/${questionId}`).then((res) => res.data);
};

// Course Week Content
export const adminCourseWeekContentGetAction = (id) => {
  return getRequest(`/admin/course-weeks/${id}/content`).then((res) => res.data);
};

export const adminCourseWeekContentUpdateAction = (id, data) => {
  return postRequest(`/admin/course-weeks/${id}/content`, data).then((res) => res.data);
};

// Course Week Sections (week_sections mapping)
export const adminCourseWeekSectionsListAction = (weekId) => {
  return getRequest(`/admin/course-weeks/${weekId}/sections`).then((res) => res.data);
};

export const adminWeekSectionsAvailableAction = (params) => {
  return getRequest(`/admin/course-week-sections`, params).then((res) => res.data);
};

export const adminWeekSectionCreateAction = (data) => {
  return postRequest(`/admin/week-sections`, data).then((res) => res.data);
};

export const adminWeekSectionUpdateAction = (id, data) => {
  return putRequest(`/admin/week-sections/${id}`, data).then((res) => res.data);
};

export const adminCourseWeekSectionGetAction = (id) => {
  return getRequest(`/admin/course-week-sections/${id}`).then((res) => res.data);
};

export const adminCourseWeekSectionCreateAction = (weekId, data) => {
  return postRequest(`/admin/course-weeks/${weekId}/sections`, data).then((res) => res.data);
};

export const adminCourseWeekSectionCreateFormDataAction = (weekId, formData) => {
  return postRequestFormData(`/admin/course-weeks/${weekId}/sections`, formData).then((res) => res.data);
};

export const adminCourseWeekSectionUpdateAction = (id, data) => {
  return putRequest(`/admin/course-week-sections/${id}`, data).then((res) => res.data);
};

export const adminCourseWeekSectionUpdateFormDataAction = (id, formData) => {
  return putRequestFormData(`/admin/course-week-sections/${id}`, formData).then((res) => res.data);
};

export const adminCourseWeekSectionDeleteAction = (id) => {
  return deleteRequest(`/admin/course-week-sections/${id}`).then((res) => res.data);
};

// Section Media
export const adminSectionMediaListAction = (weekSectionId) => {
  return getRequest(`/admin/course-week-sections/${weekSectionId}/media`).then((res) => res.data);
};

export const adminSectionMediaCreateAction = (weekSectionId, formData) => {
  return postRequestFormData(`/admin/course-week-sections/${weekSectionId}/media`, formData).then((res) => res.data);
};

export const adminSectionMediaUpdateAction = (id, formData) => {
  return putRequestFormData(`/admin/section-media/${id}`, formData).then((res) => res.data);
};

export const adminSectionMediaDeleteAction = (id) => {
  return deleteRequest(`/admin/section-media/${id}`).then((res) => res.data);
};

// Hacks (Coaching Hacks)
export const adminHacksListAction = (params) => {
  return getRequest("/admin/hacks", params).then((res) => res.data);
};

export const adminHackWeekSelectOptionsAction = () => {
  return getRequest("/admin/hacks/week-select-options").then((res) => res.data);
};

export const adminHackWeekOccupiedDaysAction = (weekId, excludeHackId) => {
  const params = { week_id: weekId };
  if (excludeHackId != null && excludeHackId !== "") params.exclude_hack_id = excludeHackId;
  return getRequest("/admin/hacks/week-occupied-days", params).then((res) => res.data);
};

export const adminHackGetAction = (id) => {
  return getRequest(`/admin/hacks/${id}`).then((res) => res.data);
};

export const adminHackCreateAction = (formData) => {
  return postRequestFormData("/admin/hacks", formData).then((res) => res.data);
};

export const adminHackUpdateAction = (id, formData) => {
  return patchRequestFormData(`/admin/hacks/${id}`, formData).then((res) => res.data);
};

export const adminHackDeleteAction = (id) => {
  return deleteRequest(`/admin/hacks/${id}`).then((res) => res.data);
};

// Daily prompts
export const adminDailyPromptsListAction = (params) => {
  return getRequest("/admin/daily-prompts", params).then((res) => res.data);
};

export const adminDailyPromptGetAction = (id) => {
  return getRequest(`/admin/daily-prompts/${id}`).then((res) => res.data);
};

export const adminDailyPromptCreateAction = (body) => {
  return postRequest("/admin/daily-prompts", body).then((res) => res.data);
};

export const adminDailyPromptUpdateAction = (id, body) => {
  return patchRequest(`/admin/daily-prompts/${id}`, body).then((res) => res.data);
};

export const adminDailyPromptDeleteAction = (id) => {
  return deleteRequest(`/admin/daily-prompts/${id}`).then((res) => res.data);
};

export const adminHelpListAction = (params) => {
  return getRequest("/admin/help", params).then((res) => res.data);
};

export const adminHelpGetAction = (id) => {
  return getRequest(`/admin/help/${id}`).then((res) => res.data);
};

export const adminHelpCreateAction = (body) => {
  return postRequest("/admin/help", body).then((res) => res.data);
};

export const adminHelpUpdateAction = (id, body) => {
  return patchRequest(`/admin/help/${id}`, body).then((res) => res.data);
};

export const adminHelpDeleteAction = (id) => {
  return deleteRequest(`/admin/help/${id}`).then((res) => res.data);
};

// Growth Snapshots (Family Growth Snapshots CMS)
export const adminGrowthSnapshotsListAction = (params) => {
  return getRequest("/admin/growth-snapshots", params).then((res) => res.data);
};

export const adminGrowthSnapshotGetAction = (id) => {
  return getRequest(`/admin/growth-snapshots/${id}`).then((res) => res.data);
};

export const adminGrowthSnapshotTreeAction = (id) => {
  return getRequest(`/admin/growth-snapshots/${id}/tree`).then((res) => res.data);
};

export const adminGrowthSnapshotCreateAction = (formData) => {
  return postRequestFormData("/admin/growth-snapshots", formData).then((res) => res.data);
};

export const adminGrowthSnapshotUpdateAction = (id, formData) => {
  return patchRequestFormData(`/admin/growth-snapshots/${id}`, formData).then((res) => res.data);
};

export const adminGrowthSnapshotDeleteAction = (id) => {
  return deleteRequest(`/admin/growth-snapshots/${id}`).then((res) => res.data);
};

export const adminGrowthSnapshotSectionsListAction = (snapshotId, params) => {
  return getRequest(`/admin/growth-snapshots/${snapshotId}/sections`, params).then((res) => res.data);
};

export const adminGrowthSnapshotSectionGetAction = (sectionId) => {
  return getRequest(`/admin/growth-snapshot-sections/${sectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotCreateSectionAction = (snapshotId, body) => {
  return postRequest(`/admin/growth-snapshots/${snapshotId}/sections`, body).then((res) => res.data);
};

export const adminGrowthSnapshotUpdateSectionAction = (sectionId, body) => {
  return patchRequest(`/admin/growth-snapshot-sections/${sectionId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotDeleteSectionAction = (sectionId) => {
  return deleteRequest(`/admin/growth-snapshot-sections/${sectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotStepsListAction = (sectionId, params) => {
  return getRequest(`/admin/growth-snapshot-sections/${sectionId}/steps`, params).then((res) => res.data);
};

export const adminGrowthSnapshotStepGetAction = (stepId) => {
  return getRequest(`/admin/growth-snapshot-steps/${stepId}`).then((res) => res.data);
};

export const adminGrowthSnapshotCreateStepAction = (sectionId, body) => {
  return postRequest(`/admin/growth-snapshot-sections/${sectionId}/steps`, body).then((res) => res.data);
};

export const adminGrowthSnapshotUpdateStepAction = (stepId, body) => {
  return patchRequest(`/admin/growth-snapshot-steps/${stepId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotDeleteStepAction = (stepId) => {
  return deleteRequest(`/admin/growth-snapshot-steps/${stepId}`).then((res) => res.data);
};

export const adminGrowthSnapshotQuestionsListAction = (stepId, params) => {
  return getRequest(`/admin/growth-snapshot-steps/${stepId}/questions`, params).then((res) => res.data);
};

export const adminGrowthSnapshotQuestionGetAction = (questionId) => {
  return getRequest(`/admin/growth-snapshot-questions/${questionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotCreateQuestionAction = (stepId, body) => {
  return postRequest(`/admin/growth-snapshot-steps/${stepId}/questions`, body).then((res) => res.data);
};

export const adminGrowthSnapshotUpdateQuestionAction = (questionId, body) => {
  return patchRequest(`/admin/growth-snapshot-questions/${questionId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotDeleteQuestionAction = (questionId) => {
  return deleteRequest(`/admin/growth-snapshot-questions/${questionId}`).then((res) => res.data);
};

// Growth Snapshot — Phase 2 content
export const adminGrowthSnapshotCategoryReflectionsListAction = (snapshotId) => {
  return getRequest(`/admin/growth-snapshots/${snapshotId}/category-reflections`).then((res) => res.data);
};

export const adminGrowthSnapshotCategoryReflectionGetAction = (reflectionId) => {
  return getRequest(`/admin/growth-snapshot-category-reflections/${reflectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotCategoryReflectionCreateAction = (snapshotId, body) => {
  return postRequest(`/admin/growth-snapshots/${snapshotId}/category-reflections`, body).then((res) => res.data);
};

export const adminGrowthSnapshotCategoryReflectionUpdateAction = (reflectionId, body) => {
  return patchRequest(`/admin/growth-snapshot-category-reflections/${reflectionId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotCategoryReflectionDeleteAction = (reflectionId) => {
  return deleteRequest(`/admin/growth-snapshot-category-reflections/${reflectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotOverallReflectionsListAction = (snapshotId) => {
  return getRequest(`/admin/growth-snapshots/${snapshotId}/overall-reflections`).then((res) => res.data);
};

export const adminGrowthSnapshotOverallReflectionGetAction = (reflectionId) => {
  return getRequest(`/admin/growth-snapshot-overall-reflections/${reflectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotOverallReflectionCreateAction = (snapshotId, body) => {
  return postRequest(`/admin/growth-snapshots/${snapshotId}/overall-reflections`, body).then((res) => res.data);
};

export const adminGrowthSnapshotOverallReflectionUpdateAction = (reflectionId, body) => {
  return patchRequest(`/admin/growth-snapshot-overall-reflections/${reflectionId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotOverallReflectionDeleteAction = (reflectionId) => {
  return deleteRequest(`/admin/growth-snapshot-overall-reflections/${reflectionId}`).then((res) => res.data);
};

export const adminGrowthSnapshotStaticScreensListAction = (snapshotId) => {
  return getRequest(`/admin/growth-snapshots/${snapshotId}/static-screens`).then((res) => res.data);
};

export const adminGrowthSnapshotStaticScreenGetAction = (screenId) => {
  return getRequest(`/admin/growth-snapshot-static-screens/${screenId}`).then((res) => res.data);
};

export const adminGrowthSnapshotStaticScreenCreateAction = (snapshotId, body) => {
  return postRequest(`/admin/growth-snapshots/${snapshotId}/static-screens`, body).then((res) => res.data);
};

export const adminGrowthSnapshotStaticScreenUpdateAction = (screenId, body) => {
  return patchRequest(`/admin/growth-snapshot-static-screens/${screenId}`, body).then((res) => res.data);
};

export const adminGrowthSnapshotStaticScreenDeleteAction = (screenId) => {
  return deleteRequest(`/admin/growth-snapshot-static-screens/${screenId}`).then((res) => res.data);
};

// Journals (Journal Entries)
export const adminJournalEntriesListAction = (params) => {
  return getRequest("/admin/journal-entries", params).then((res) => res.data);
};

export const adminJournalEntriesStatsAction = (params) => {
  return getRequest("/admin/journal-entries/stats", params).then((res) => res.data);
};

export const adminJournalEntryGetAction = (id) => {
  return getRequest(`/admin/journal-entries/${id}`).then((res) => res.data);
};

// Xero (admin panel)
export const adminXeroStatusAction = () => {
  return getRequest("/admin/xero/status").then((res) => res.data);
};

export const adminXeroConnectAction = () => {
  return getRequest("/admin/xero/connect").then((res) => res.data);
};

export const adminXeroDisconnectAction = () => {
  return postRequest("/admin/xero/disconnect", {}).then((res) => res.data);
};

export const adminXeroSettingsGetAction = () => {
  return getRequest("/admin/xero/settings").then((res) => res.data);
};

export const adminXeroSettingsUpdateAction = (data) => {
  return putRequest("/admin/xero/settings", data).then((res) => res.data);
};

export const adminXeroAccountsAction = () => {
  return getRequest("/admin/xero/accounts").then((res) => res.data);
};

export const adminXeroTaxRatesAction = () => {
  return getRequest("/admin/xero/tax-rates").then((res) => res.data);
};

export const adminXeroSyncGetAction = (purchaseId) => {
  return getRequest(`/admin/xero/sync/${purchaseId}`).then((res) => res.data);
};

export const adminXeroSyncRetryAction = (purchaseId) => {
  return postRequest(`/admin/xero/sync/${purchaseId}/retry`, {}).then((res) => res.data);
};

// Global Settings
export const adminGlobalSettingsListAction = () => {
  return getRequest("/admin/global-settings").then((res) => res.data);
};

export const adminGlobalSettingCreateAction = (data) => {
  return postRequest("/admin/global-settings", data).then((res) => res.data);
};

export const adminGlobalSettingUpdateAction = (id, data) => {
  return patchRequest(`/admin/global-settings/${id}`, data).then((res) => res.data);
};

export const adminGlobalSettingsUploadLogoAction = (formData) => {
  return postRequestFormData("/admin/global-settings/upload-logo", formData).then((res) => res.data);
};

export const adminGlobalSettingsUploadIntroSupportFileAction = (formData) => {
  return postRequestFormData("/admin/global-settings/upload-intro-support-file", formData).then((res) => res.data);
};

export const adminAppVersionUpdateAction = (data) => {
  if (data instanceof FormData) {
    return postRequestFormData("/admin/app-version", data).then((res) => res.data);
  }
  return postRequest("/admin/app-version", data).then((res) => res.data);
};

/** Public legal page content (GET /api/v1/settings or proxied /api/settings). No auth required. */
export const publicLegalSettingsAction = () => {
  return getRequest("/settings").then((res) => res.data);
};

// Info Videos
export const adminInfoVideosListAction = (params) => {
  return getRequest("/admin/info-videos", params).then((res) => res.data);
};

export const adminInfoVideoGetAction = (id) => {
  return getRequest(`/admin/info-videos/${id}`).then((res) => res.data);
};

export const adminInfoVideoCreateAction = (formData) => {
  return postRequestFormData("/admin/info-videos", formData).then((res) => res.data);
};

export const adminInfoVideoUpdateAction = (id, formData) => {
  return patchRequestFormData(`/admin/info-videos/${id}`, formData).then((res) => res.data);
};

export const adminInfoVideoDeleteAction = (id) => {
  return deleteRequest(`/admin/info-videos/${id}`).then((res) => res.data);
};

// CMS Content
export const adminCmsContentListAction = (params) => {
  return getRequest("/admin/cms-content", params).then((res) => res.data);
};

export const adminCmsContentGetAction = (id) => {
  return getRequest(`/admin/cms-content/${id}`).then((res) => res.data);
};

export const adminCmsContentCreateAction = (data) => {
  return postRequest("/admin/cms-content", data).then((res) => res.data);
};

export const adminCmsContentUpdateAction = (id, data) => {
  return patchRequest(`/admin/cms-content/${id}`, data).then((res) => res.data);
};

export const adminCmsContentDeleteAction = (id) => {
  return deleteRequest(`/admin/cms-content/${id}`).then((res) => res.data);
};

// Sales Content (Brave Brain Academy sales screen)
export const adminSalesContentListAction = (params) => {
  return getRequest("/admin/sales-content", params).then((res) => res.data);
};

export const adminSalesContentGetAction = (id) => {
  return getRequest(`/admin/sales-content/${id}`).then((res) => res.data);
};

export const adminSalesContentCreateAction = (body) => {
  return postRequest("/admin/sales-content", body).then((res) => res.data);
};

export const adminSalesContentUpdateAction = (id, body) => {
  return patchRequest(`/admin/sales-content/${id}`, body).then((res) => res.data);
};

export const adminSalesContentDeleteAction = (id) => {
  return deleteRequest(`/admin/sales-content/${id}`).then((res) => res.data);
};

// Resource Hub
export const adminResourceHubListAction = (params) => {
  return getRequest("/admin/resource-hub", params).then((res) => res.data);
};

export const adminResourceHubGetAction = (id) => {
  return getRequest(`/admin/resource-hub/${id}`).then((res) => res.data);
};

export const adminResourceHubCreateAction = (formData) => {
  return postRequestFormData("/admin/resource-hub", formData).then((res) => res.data);
};

export const adminResourceHubUpdateAction = (id, formData) => {
  return putRequestFormData(`/admin/resource-hub/${id}`, formData).then((res) => res.data);
};

export const adminResourceHubDeleteAction = (id) => {
  return deleteRequest(`/admin/resource-hub/${id}`).then((res) => res.data);
};

// Export helpers too (optional convenience)
export {
  getRequest,
  postRequest,
  putRequest,
  patchRequest,
  deleteRequest,
  postRequestFormData,
  putRequestFormData,
  patchRequestFormData
};

